import React from 'react'
import CardContainer from '../../../Shared/Card/CardContainer'
import { profile_icon } from '../../../Shared/icons'
import useApi from '../../../../hooks/useApi'
import { useParams } from "react-router-dom";
import EditAlreadyMember from '../../../Shared/User/EditAlreadyMember';
import { LoadingComponent } from 'usbc-web-react-library'
import { updateStepData } from '../../../Shared/helpers';

function ViewBowlerInfo(props) {

    const [values, setValues] = React.useState({});
    const [buttonsMode, setButtonsMode] = React.useState(null);

    let { lid, season } = useParams();

    const {
        fetchData: getBowlerInfo,
        loading: bowlerInfoLoading,
        response: bowlerInfo
    } = useApi();

    React.useEffect(() => {
        getBowlerInfo({ url: 'getbowlerinfo/' + lid + '/' + props.wizardState.memberId + '/' + season }).then(result => {
            setValues(result);
            if (result.shouldFillEmail === true || result.shouldFillPhone === true || result.shouldFillExtdFields === true || result?.guardian?.requiresGuardianEmail) {
                setButtonsMode("Edit");
            } else {
                setButtonsMode("View");
            }
        });
    }, []);

    function onUserInfoSave(bowler) {
        let stepData = props.wizardState;
        stepData = updateStepData(stepData, {
            bowlerProfile: bowler,
            isPaymentRequired: bowlerInfo.isPaymentRequired
        })
        props.updateWizardState(stepData)
        props.nextView(stepData);
    }
    function onNextClick() {
        let stepData = props.wizardState;
        stepData = updateStepData(stepData, {
            isPaymentRequired: bowlerInfo.isPaymentRequired
        })
        props.updateWizardState(stepData)
        props.nextView(stepData);
    }
    return (

        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title}
                </div>
            </div>
            <LoadingComponent isLoading={() => bowlerInfoLoading === true} description="Loading Bowler Information">
                <div className="row">
                    {values != null &&
                        <div className="row g-0" >
                            <div className="col-md-3 center-parent stepIcon">
                                {profile_icon}
                            </div>
                            <div className="col-md-9" style={{ display: 'flex', alignItems: "center" }}>
                                <div className="card-body">
                                    <CardContainer title="Bowler Profile">
                                        <div className='mb-3'>
                                            <div className='row'>
                                                <div className="col-md-4">
                                                    <label htmlFor="firstName" className="form-label">First</label>
                                                    <input type="text" className="form-control" id="firstName" name='firstName' value={values?.firstName} disabled />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="initial" className="form-label">MI</label>
                                                    <input type="text" className="form-control" id="initial" name='initial' value={values?.initial} disabled />
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="lastName" className="form-label">Last</label>
                                                    <input type="text" className="form-control" id="lastName" name='lastName' value={values?.lastName} disabled />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="suffix" className="form-label">Suffix</label>
                                                    <input type="text" className="form-control" id="suffix" name='suffix' value={values?.suffix} disabled />
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                < div className="col-md-6">
                                                    <label htmlFor="memberId" className="form-label">Member Id</label>
                                                    <input type="text" className="form-control" id="memberId" name='memberId' value={values?.memberId} disabled />
                                                </div>
                                                < div className="col-md-6">
                                                    <label htmlFor="association" className="form-label">Association</label>
                                                    <input type="text" className="form-control" id="association" name='association' value={values?.association} disabled />
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="competitionGenderClassification" className="form-label">Competition Gender Classification</label>
                                                        <select className="form-select" id="competitionGenderClassification" name='competitionGenderClassification' value={values?.gender} disabled>
                                                            <option value="">Select</option>
                                                            <option value="M">Male/Open</option>
                                                            <option value="F">Female</option>
                                                        </select>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (values.shouldFillEmail === true || values.shouldFillPhone === true || values.shouldFillExtdFields === true || values?.guardian?.requiresGuardianEmail === true) &&
                                            <EditAlreadyMember onUserInfoSave={onUserInfoSave} bowlerProfile={values} />

                                        }

                                    </CardContainer>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className='wizard-buttons-container'>
                    <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
                    {!!buttonsMode &&
                        buttonsMode === "View" ?
                        <button type="button" className="btn btn-primary bowl-btn" onClick={() => onNextClick()}>Next</button>
                        :
                        <button type="submit" form='userinfo-form' className="btn btn-primary bowl-btn">Next</button>

                    }
                </div>
            </LoadingComponent>
        </>

    )
};

export default ViewBowlerInfo;

